import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { VStack, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class PDenied extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDenied.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullHeight VAlign="-" spacing={20}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Your account is Inactive, or Deleted.",
            TC: "你的帳號已停用或刪除"
          })}
        </XText>
        <XText fontSize={16} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Please contact customer service, or try again later.",
            TC: "請聯絡客戶服務，或稍後再試。"
          })}
        </XText>
      </VStack>
    );
  }

}

export default observer(PDenied);
